<template>
    <div class="float-box-body">
      <el-empty v-if="reports.length === 0" description="暂无患者数据" />
      <el-table v-else :data="reports" stripe style="width: 100%">
        <el-table-column prop="patientName" label="患者姓名" width="120" />
        <el-table-column prop="gender" label="性别" width="80">
          <template slot-scope="scope">
            {{ scope.row.gender === 'MALE' ? '男' : '女' }}
          </template>
        </el-table-column>
        <el-table-column prop="birthday" label="生日" width="120">
          <template slot-scope="scope">
            {{ formatDate(scope.row.birthday) }}
          </template>
        </el-table-column>
        <el-table-column prop="createdAt" label="检查日期" width="150">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createdAt) }}
          </template>
        </el-table-column>
        <el-table-column prop="hospital" label="医院" min-width="150" />
        <el-table-column label="报告" width="120" fixed="right">
          <template slot-scope="scope">
            <el-link type="primary" @click="downloadReport(scope.row.reportUrl, scope.row.patientName, scope.row.createdAt)">
              点击下载
            </el-link>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="reports.length > 0" class="pagination" style="display: flex; justify-content: flex-end; margin-top: 20px;">
        <el-pagination
          background
          small
          layout="prev, pager, next"
          :total="totalCount"
          :page-size="pageSize"
          :current-page="currentPage"
          @current-change="handlePageChange"
        />
      </div>
    </div>
</template>

<script>
import axios from 'axios';
import config from '@/http/config';
import { resolveStationId } from '@/common/util.js';

export default {
  name: 'ReportList',
  props: {
    searchParams: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showFloatBox: true, // 默认显示，即使未登录也可以看到组件框架
      reports: [],
      searchName: '',
      currentPage: 1, // Element UI分页组件默认从1开始
      pageSize: 5,
      totalCount: 0,
      // Mock数据，用于展示效果
      mockData: [
        {
          id: '1',
          patientName: '张三',
          gender: 'MALE',
          birthday: '2019-08-03T16:00:00.000+0000',
          createdAt: '2023-10-15T10:30:00.000+0000',
          hospital: '测试医疗机构',
          reportUrl: '/api/reports/1' // 添加报告URL
        },
        {
          id: '2',
          patientName: '李四',
          gender: 'FEMALE',
          birthday: '2018-05-20T16:00:00.000+0000',
          createdAt: '2023-10-14T09:15:00.000+0000',
          hospital: '眼科中心',
          reportUrl: '/api/reports/2' // 添加报告URL
        },
        {
          id: '3',
          patientName: '王五',
          gender: 'MALE',
          birthday: '2016-09-30T16:00:00.000+0000',
          createdAt: '2023-10-13T14:45:00.000+0000',
          hospital: '儿童视力保健中心',
          reportUrl: '/api/reports/3' // 添加报告URL
        }
      ]
    };
  },
  watch: {
    // 监听搜索参数变化，重新查询数据
    searchParams: {
      handler(newParams) {
        console.log("newParams:", newParams);
        if (newParams) {
          this.searchName = newParams.patientName || '';
          this.currentPage = 1; // 与Element UI分页组件保持一致，从1开始
          this.fetchPatientList(newParams);
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    // 检查用户是否登录
    if (localStorage.getItem('token')) {
      this.fetchPatientList(this.searchParams);
    } else {
      // 未登录时显示mock数据
      this.reports = this.mockData;
      this.totalCount = this.mockData.length;
    }
  },
  methods: {
    async fetchPatientList(params = {}) {
      try {
        // 构建参数对象，与admin.js中queryPatients方法参数格式匹配
        const queryParams = {
          name: params.patientName || this.searchName || '',
          page: this.currentPage - 1, // 转换为从0开始的页码发送给后台
          size: this.pageSize
        };
        console.log("currentPath:", this.currentPage);
        // 添加可选参数
        if (params.birthday) {
          queryParams.birthday = params.birthday;
        }
        if (params.gender) {
          queryParams.gender = params.gender;
        }
        // 携带站点ID，后端将返回本人及该站点的报告；缺失时不传（后端降级为仅查本人）
        const stationId = await resolveStationId(this.$http.admin.findHospitalName);
        if (stationId) {
          queryParams.stationId = stationId;
        }

        const result = await this.$http.admin.queryPatients(queryParams);
        console.log('查询患者列表结果:', result);
        if (result && result.totalElements) {
          this.reports = result.content;
          this.totalCount = result.totalElements;
        } else {
          this.reports = [];
          this.totalCount = 0;
        }
      } catch (error) {
        console.error('获取患者列表失败:', error);
        this.$message.error('获取患者列表失败，请重试！');
        // 发生错误时显示mock数据
        this.reports = this.mockData;
        this.totalCount = this.mockData.length;
      }
    },

    handleSearch() {
      // 重置页码并重新查询x
      this.currentPage = 1; // 与Element UI分页组件保持一致，从1开始
      console.log("currentPage:", this.currentPage);
      if (localStorage.getItem('token')) {
        this.fetchPatientList();
      } else {
        // 未登录状态下的本地搜索
        if (this.searchName.trim()) {
          this.reports = this.mockData.filter(patient =>
            patient.patientName.includes(this.searchName.trim())
          );
        } else {
          this.reports = this.mockData;
        }
        this.totalCount = this.reports.length;
      }
    },

    handlePageChange(page) {
      this.currentPage = page; // Element UI分页组件会自动处理页码，无需转换
      if (localStorage.getItem('token')) {
        this.fetchPatientList(this.searchParams);
      } else {
        // 未登录状态下的本地分页（简单处理）
        // 由于mock数据较少，这里不做复杂分页逻辑
      }
    },

    // 格式化日期显示
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },

    // 带token认证的报告下载方法
    async downloadReport(reportUrl, patientName, checkDate) {
      if (!reportUrl) {
        this.$message.warning('报告链接不存在');
        return;
      }

      if (!localStorage.getItem('token')) {
        this.$message.warning('请先登录');
        return;
      }

      try {
        // 创建带token的请求头
        const headers = {
          'x-auth-token': localStorage.getItem('token')
        };

        // 处理报告链接，确保生成正确的URL
        let fullReportUrl = reportUrl;

        // 检查是否是完整的URL（http:// 或 https:// 开头）
        if (!/^https?:\/\//i.test(reportUrl)) {
          // 如果是相对路径，根据是否以/开头来决定是否添加baseURL
          if (reportUrl.startsWith('/')) {
            // 以/开头的相对路径，直接添加baseURL
            fullReportUrl = `${config.baseURL}${reportUrl}`;
          } else {
            // 不以/开头的相对路径，添加baseURL和/
            fullReportUrl = `${config.baseURL}/${reportUrl}`;
          }
        }

        // 发送GET请求下载文件，设置responseType为blob
        const response = await axios.get(fullReportUrl, {
          headers,
          responseType: 'blob'
        });

        // 使用患者姓名和检查日期作为文件名
        const formattedDate = this.formatDate(checkDate);
        let fileName = `检查报告-${patientName}${formattedDate}.pdf`;

        // 如果响应头中有文件名信息，优先使用响应头中的文件名
        const contentDisposition = response.headers['content-disposition'];
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
          if (fileNameMatch && fileNameMatch.length > 1) {
            fileName = fileNameMatch[1];
          }
        }

        // 创建临时URL并触发下载
        const blobUrl = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = blobUrl;
        link.download = fileName;
        link.click();

        // 清理临时URL
        window.URL.revokeObjectURL(blobUrl);
      } catch (error) {
        console.error('下载报告失败:', error);
        console.error('报告原始URL:', reportUrl);
        this.$message.error('下载报告失败，请重试！');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.patient-list-float {
  position: fixed;
  left: 15px;
  top: 100px;
  width: 90%;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 1000;
  max-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
  transition: all 0.3s ease;
  overflow: hidden;
}

.float-box-header {
  padding: 15px;
  border-bottom: 1px solid #f0f0f0;
  h3 {
    margin: 0 0 10px 0;
    font-size: 16px;
    font-weight: 500;
    color: #333;
  }
  .search-container {
    display: flex;
    gap: 10px;
    .search-input {
      flex: 1;
    }
    .search-button {
      min-width: 80px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/ReportList.vue